export default __webpack_public_path__ + "static/media/project13.83bce301.webp";